<div class="product-card mx-auto" [class.app-mode-card]="appMode">
  <div class="product-img-container">
    <span class="new-badge" *ngIf="data.isNew">NEW</span>
    <button
      *ngIf="appMode"
      type="button"
      class="wishlist-btn"
      [class.active]="isWishlisted"
      (click)="toggleWishlist($event)"
      aria-label="Add to wishlist"
    >
      <i class="bi" [ngClass]="isWishlisted ? 'bi-heart-fill' : 'bi-heart'"></i>
    </button>
    <img [src]="data.imagePath" alt="Red sports jersey" class="product-img" />
  </div>
  <div class="product-info">
    <h5 class="product-title">{{ data.name }}</h5>
    <p class="product-price" *ngIf="convertedPrice !== null">
      {{ convertedPrice | number: '1.2-2' }} {{ currencySymbol }}
    </p>
  </div>
</div>
